/**
 * @info
 *
 * *The "store/product" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind cart functionality.
 *
 * *This file*
 * This file outlines "state". This is the starting snapshot
 * of the modules underlying state. As the user interacts with
 * the components tied into this Vuex module, this state is modified
 * away from these default values.
 */

import { categorySwatchOptionMarkup } from 'utils/general'

export default {
  loading: false,
  isStatic: false,
  product: {
    variants: { edges: [] },
    media: { edges: [] }
  },
  metafields: false,
  variant: {
    id: false,
    price: false,
    compareAtPrice: false,
    available: true,
    option: '',
    sku: '',
    image: {
      src: '',
      altText: ''
    }
  },
  activeImage: 0,
  reviews: {
    loading: true,
    pagination: false,
    bottomline: false,
    reviews: false,
    code: false,
    writeReview: false
  },
  quickView: {
    id: false,
    handle: false,
    product: false
  },
  sizes: false,
  activeCategory: {
    label: categorySwatchOptionMarkup('all', 'All Shades'),
    value: 'all'
  },
  customSelected: [],
  subscription: true,
  showingTryShade: false
}
